import useSelectContext from "../hooks/useSelectContext";

// eslint-disable-next-line import/prefer-default-export
export var SelectContext = useSelectContext();